import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import { LockIcon } from "@/features/pathpick/components/PathPickMembershipExpiredPanel";

// NO_MEMBERSHIP: 멤버십 미가입 바이어 — 멤버십 페이지로 안내한다.
// NOT_BUYER: 에이전시 등 바이어가 아닌 계정 — 멤버십을 시작할 수 없으므로 홈 이동만 준다.
export type PathPickAccessDeniedReason = "NO_MEMBERSHIP" | "NOT_BUYER";

interface PathPickAccessDeniedPanelProps {
  reason: PathPickAccessDeniedReason;
}

/**
 * 패스픽 이용 권한이 없는 사용자가 URL로 직접 들어왔을 때의 안내(PathPickAccessGuard 전용).
 * 만료 잠금 패널과 같은 표현을 쓰되, 여기서는 갈 곳이 없으므로 이동 버튼만 준다.
 */
function PathPickAccessDeniedPanel({ reason }: PathPickAccessDeniedPanelProps) {
  const { t } = useI18nHelper();
  const isNotBuyer = reason === "NOT_BUYER";
  // 로케일 프리픽스를 붙여 주는 navigate.
  const { navigate } = useRouterHelper();

  return (
    <Flex
      flex={1}
      minHeight={"420px"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={"16px"}
      padding={"32px"}
      border={"1px solid #E5E5E3"}
      borderRadius={"8px"}
      background={"#FFFFFF"}
    >
      <Flex
        boxSize={"48px"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"full"}
        background={"#E8F2FF"}
      >
        <LockIcon />
      </Flex>
      <Flex flexDirection={"column"} gap={"8px"} alignItems={"center"}>
        <Text
          textStyle={"body-lg-bold"}
          fontSize={"22px"}
          color={"#1D1D1B"}
          textAlign={"center"}
        >
          {t("path_pick:access_denied.title")}
        </Text>
        <Text
          textStyle={"body-md-regular"}
          color={"#6F6F6C"}
          textAlign={"center"}
          maxWidth={"520px"}
        >
          {isNotBuyer
            ? t("path_pick:access_denied.description_buyer_only")
            : t("path_pick:access_denied.description")}
        </Text>
      </Flex>
      <Flex gap={"8px"}>
        {!isNotBuyer && (
          <AppButton
            variant={"primary"}
            onClick={() => navigate("/pathpick/membership")}
          >
            {t("path_pick:access_denied.cta_membership")}
          </AppButton>
        )}
        <AppButton variant={"white"} onClick={() => navigate("/")}>
          {t("path_pick:access_denied.cta_home")}
        </AppButton>
      </Flex>
    </Flex>
  );
}

export default PathPickAccessDeniedPanel;
